import React from 'react';
import styles from './styles.module.scss';
import DataTableWithFilters from '../DataTableWithFilters';

const DataTableWidget = ({
                           customClassNames = {},
                           title,
                           ...rest
                         }) => (
  <div className={`${styles.listContainer} ${customClassNames.listContainer || ''}`}>
    <h1 className={styles.pageTitle}>{title}</h1>
    <DataTableWithFilters
      customClassNames={customClassNames}
      {...rest}
    />
  </div>
);

export default DataTableWidget;
